import { render, staticRenderFns } from "./FlatInfo.vue?vue&type=template&id=5ded9be3&scoped=true&"
import script from "./FlatInfo.vue?vue&type=script&lang=js&"
export * from "./FlatInfo.vue?vue&type=script&lang=js&"
import style0 from "./FlatInfo.vue?vue&type=style&index=0&id=5ded9be3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ded9be3",
  null
  
)

export default component.exports